import { formatMoney } from 'accounting'

import { Box, DashboardModule, Text } from '@domain-group/suit-theme'

import type { CampaignModel } from '@models/types'

type CampaignFeeProps = {
  boxProps?: {},
  campaign: CampaignModel,
  title?: string,
}

const CampaignFee = (props: CampaignFeeProps) => {
  const {
    boxProps,
    campaign: { campaign_fee },
    title,
  } = props

  // @ts-expect-error TS18048
  if (campaign_fee <= 0 || campaign_fee === undefined){
    return null
  }

  return (
    <DashboardModule boxProps={boxProps} title="Campaign Fee">
      <Box padding="large">
        <Text fontSize="small">{title || 'Campaign Fee'}</Text>

        <Text color="bodyFontLightColor" fontSize="small" marginLeft="auto">
          {formatMoney(campaign_fee)}
        </Text>
      </Box>
    </DashboardModule>
  )
}

export default CampaignFee
